<template>
  <div class="queue" :style="[style, getType()]">
    <div class="h-full w-full" :style="{ maxHeight: sectionHeight }">
      <p v-multi-ref:resize>{{ queue.name }}</p>
    </div>
    <div
      class="flex h-full w-full"
      :style="{ maxHeight: sectionHeight }"
      v-if="showDetails"
    >
      <div
        class="w-full h-full"
        v-if="conf.statsToDisplay.includes('TotalCalls')"
      >
        <p v-multi-ref:resize>Total Calls: {{ queue.totalCalls }}</p>
      </div>
      <div
        class="w-full h-full"
        v-if="conf.statsToDisplay.includes('AbandonedCalls')"
      >
        <p v-multi-ref:resize>Abandoned: {{ queue.abandoned }}</p>
      </div>
      <div
        class="w-full h-full"
        v-if="conf.statsToDisplay.includes('AbandonRate')"
      >
        <p v-multi-ref:resize>Abandon Rate: {{ queue.abandonRate }}</p>
      </div>
    </div>
    <div
      class="flex h-full w-full"
      :style="{ maxHeight: sectionHeight }"
      v-if="showQueue"
    >
      <div
        class="w-full h-full"
        v-if="conf.statsToDisplay.includes('CallsInQueue')"
      >
        <p v-multi-ref:resize>Queuing: {{ queue.calls }}</p>
      </div>
      <div
        class="w-full h-full"
        v-if="conf.statsToDisplay.includes('OldestCallInQueue')"
      >
        <p v-multi-ref:resize>Oldest: {{ getCallTime(queue.oldestDT) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    queue: {
      required: true,
      value: Object,
    },

    shouldResize: {
      required: true,
      value: Boolean,
    },

    conf: {
      required: true,
      value: Object,
    },

    sectionHeight: {
      required: true,
      value: String,
    },

    height: Number,
  },

  mounted() {
    setTimeout(
      () =>
        this.$nextTick(() => {
          this.resizeText({
            elements: this.$refs.resize,
          });
        }),
      500
    );
  },

  watch: {
    shouldResize() {
      this.$nextTick(() => {
        this.resizeText({
          elements: this.$refs.resize,
        });
      });
      this.$emit("resized");
    },

    conf: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.resizeText({
            elements: this.$refs.resize,
          });
        });
      },
    },
  },

  computed: {
    style() {
      return {
        height: this.height + "px",
      };
    },

    showDetails() {
      return (
        this.conf.statsToDisplay.filter((x) =>
          ["AbandonedCalls", "AbandonRate", "TotalCalls"].includes(x)
        ).length > 0
      );
    },

    showQueue() {
      return (
        this.conf.statsToDisplay.filter((x) =>
          ["CallsInQueue", "OldestCallInQueue"].includes(x)
        ).length > 0
      );
    },
  },

  methods: {
    getType() {
      if (this.queue.calls == 0) return { backgroundColor: "#FFFFFF" };
      if (this.conf.flash) {
        var val = this.flash();
        return val;
      }
      if (this.conf.fixedColor) return this.getColour(this.queue.calls);
    },

    getCallTime(time) {
      if (!time) return "0h 0m 0s";
      return this.toHMS(this.now - new Date(Date.parse(time)));
    },

    getColour(calls) {
      var color = {};
      var sorted = this.conf.fixedColors;
      for (let i = 0; i < sorted.length; i++) {
        if (calls >= parseInt(sorted[i].volume)) color = sorted[i].color;
      }
      return { backgroundColor: color };
    },

    flash() {
      var val = Math.round(this.now / 1000);
      if (val % 2 == 0) return { backgroundColor: this.conf.flashColors.first };
      else return { backgroundColor: this.conf.flashColors.second };
    },
  },
};
</script>

<style scoped>
.queue {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom-style: solid;
  border-bottom-color: grey;
  border-bottom-width: 1px;
  min-height: 50px;
  overflow: hidden;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.w-full {
  width: 100%;
}

.h-full {
  height: 100%;
}
</style>